  
  <ion-content [hidden]="searchResultsEnable" (messageEvent)="receiveMessage($event)"> 
  <custom-super-tabs *ngIf="tabsvisible" id="child" #childTab tabsPlacement="top" scrollTabs="true" (tabSelect)="onTabSelect($event)">
    <custom-super-tab *ngFor="let tab of tabs" [id]="tab.id" [root]="tab.root" [title]="tab.title" [rootParams]="tab.params"></custom-super-tab>
  </custom-super-tabs> 

 <!--  <ion-tabs *ngIf="tabsvisible" id="child"  tabsPlacement="top" scrollTabs="true" (tabSelect)="onTabSelect($event)">
    <ion-tab *ngFor="let tab of tabs" [id]="tab.id" [root]="tab.root" [tabTitle]="tab.title" [rootParams]="tab.params"></ion-tab>
  </ion-tabs>  -->
  
<!--   <ion-spinner name="bubbles"></ion-spinner>
 -->
    
      <!-- <ion-content class="content-top-margin"> -->

 </ion-content> 

 <ion-content  *ngIf="searchResultsEnable">
  <search-results-page [params]="searchparams"></search-results-page>
  
  </ion-content> 

 <!-- <super-tabs  tabsPlacement="top" scrollTabs="true">
    <super-tab *ngFor="let tab of tabs" [root]="tab.root" [title]="tab.title" [rootParams]="tab.params"></super-tab>
  </super-tabs>  -->

  <ion-content  *ngIf="!isNetworkConnected">
      <ion-row class="no_network_message">
          <ion-col text-center>
              The Discounts & Rewards search engine is currently unavailable.<br>
              Please try again in a short while
          </ion-col>
      </ion-row>
      
  </ion-content>    
